@if ((layoutService.componentsConfig$ | async); as layoutConfig) {
  <main class="content">
    <div class="center">
      <div class="map" #mapContainer>
        @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.FEATURE_INFO)) {
          <tm-feature-info></tm-feature-info>
        }
        <tm-map></tm-map>
        <div class="map-controls-left">
          @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.MEASURE)) {
            <tm-measure></tm-measure>
          }
          @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.COORDINATE_PICKER)) {
            <tm-clicked-coordinates></tm-clicked-coordinates>
          }
          @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.STREETVIEW)) {
            <tm-streetview></tm-streetview>
          }
          @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.SIMPLE_SEARCH)) {
            <tm-simple-search role="search"></tm-simple-search>
          }
          @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.TERRAIN_LAYER_TOGGLE)
          || layoutService.isComponentEnabled(layoutConfig, componentTypes.TERRAIN_OPACITY)) {
            <tm-terrain-controls></tm-terrain-controls>
          }
        </div>
        <div class="map-controls-right">
          @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.BACKGROUND_LAYER_TOGGLE)) {
            <tm-background-layer-toggle></tm-background-layer-toggle>
          }
          <div class="map-controls-column">
            @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.ZOOM)) {
              <tm-zoom-buttons></tm-zoom-buttons>
            }
            @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.GEOLOCATION)) {
              <tm-geolocation></tm-geolocation>
            }
          </div>
        </div>
        <div class="map-controls-left map-controls-left--on-bottom">
          @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.SCALE_BAR)) {
            <tm-scale-bar></tm-scale-bar>
          }
        </div>
        <div class="map-controls-right map-controls-right--on-bottom">
          @if (layoutService.isComponentEnabled(layoutConfig, componentTypes.MOUSE_COORDINATES)) {
            <tm-mouse-coordinates></tm-mouse-coordinates>
          }
        </div>
      </div>
    </div>
  </main>
}
